module.exports = __webpack_public_path__ + "static/media/left_arrow.21f175cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/left_arrow.png
// module id = 501
// module chunks = 0